import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave";
import {
  IGetMetaParams,
  IMetaForm,
  IPageMetaDTO,
  IMetaDTO,
  IMetaFormUpdate,
} from "../../types/meta";
import { removeEmpty } from "../../utils/removeEmpty";

const basePath = "/meta";

export class Meta {
  static async get(
    props?: IGetMetaParams
  ): Promise<AxiosResponse<IPageMetaDTO>> {
    let params = "";

    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values).toString();
    }

    return ApiBrave.get(params ? `${basePath}?${params}` : basePath);
  }

  static async getById(uuid: string): Promise<AxiosResponse<IMetaDTO>> {
    return ApiBrave.get(`${basePath}/${uuid}`);
  }

  static async post(data: IMetaForm): Promise<AxiosResponse<IMetaDTO>> {
    return ApiBrave.post(basePath, data);
  }

  static async put({
    uuid,
    ...rest
  }: IMetaFormUpdate): Promise<AxiosResponse<IMetaDTO>> {
    return ApiBrave.put(`${basePath}/${uuid}`, rest);
  }
}
